import modules_setting from './setting/index.js'
import modules_list from './list/index.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    modules:{
        list: modules_list,
        setting: modules_setting,
    },
}